import {capitalize, upperCaseName} from "../../../helper/tools";
import {useEffect, useState} from "react";
import useAuth from "../../../hooks/useAuth";
import DeceasedInfos from "./deceased views/DeceasedInfos";
import AdminInfos from "./deceased views/AdminInfos";
import ObsequesInfos from "./deceased views/ObsequesInfos";
import FormAddEvent from "../../../forms/deceased/infos_obs/FormAddEvent";
import FormDeceasedNew from "../../../forms/deceased/FormDeceasedNew";
import FormDeceasedComplement from "../../../forms/FormDeceasedComplement";
import {getEventList, getEventAddedInfos} from "../../../api/pro/eventReq";
import { useParams } from "react-router-dom";
import FormGeneralInfos from "../../../forms/deceased/FormGeneralInfos";
import FormDeathInfos from "../../../forms/deceased/FormDeathInfos";
import FormBirthInfos from "../../../forms/deceased/FormBirthInfos";
import FormDeceasedInfos from "../../../forms/deceased/FormDeceasedInfos";
import FormAddedInfos from "../../../forms/deceased/infos_obs/FormAddedInfos";
import FormEFCreate from "../../../forms/deceased/FormEFCreate";
import Icon from "../../../components/common/Icon";

export default function ViewDeceasedMainInfos({ apiDeceasedInfos, deceasedInfos, partnerInfos, adminInfos, correspondentInfos}) {

    const [ selectedTab, setSelectedTab] = useState("defunt");
    const [showAddEventModal, setShowAddEventModal] = useState(false);
    const [showEditDeceasedModal, setShowEditDeceasedModal] = useState(false);
    const [showEditComplementModal, setShowEditComplementModal] = useState(false);
    const [showThoughtsModal, setShowThoughtsModal] = useState(false);
    const [showModalEF, setShowModalEF] = useState(false);
    const isGestionnaireComplete = !!(adminInfos?.address || correspondentInfos?.address);
    const [ eventList, setEventList ] = useState([]);
    const [ eventId, setEventId ] = useState(0);
    const [ eventKey, setEventKey ] = useState();
    const [ eventsLoaded, setEventsLoaded ] = useState(false);
    const [addedInfos, setAddedInfos] = useState(null);
    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();

    const calculateAge = (birthDate, deathDate) => {
        if (!birthDate || !deathDate) return null;
        
        const birth = new Date(birthDate);
        const death = new Date(deathDate);
        
        let age = death.getFullYear() - birth.getFullYear();
        const monthDiff = death.getMonth() - birth.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && death.getDate() < birth.getDate())) {
            age--;
        }
        
        return age;
    };

    const age = calculateAge(deceasedInfos?.birthDate, deceasedInfos?.deathDate);


    const handleTabChange = (tab) => {
        setSelectedTab(tab);
    }

    const addEvent = () => {
        setEventId(0);
        setEventKey(undefined);
        setShowAddEventModal(true);
    }

    useEffect(() => {
        if (!eventsLoaded || (id && deceasedInfos?.id && deceasedInfos.id !== eventList[0]?.deceasedId)) {
            apiEventList();
        }
    }, [ id, deceasedInfos?.id ]);

    const parseEventDateTime = (event) => {
        if (!event?.date) return null;
        const [day, month, year] = event.date.split('/').map(Number);
        if (!day || !month || !year) return null;
        const [hours, minutes] = (event?.time || '00:00').split(':').map(Number);
        return new Date(year, month - 1, day, hours || 0, minutes || 0);
    };

    const isVisitEvent = (event) => {
        const label = (event?.eventTypeLabel || event?.typeLabel || '').toLowerCase();
        return label.includes('visite');
    };

    const apiEventList = async () => {
        const response = await getEventList(token, id)

        // Trier les événements : visites sur période en premier, puis par date et heure croissantes
        if (Array.isArray(response) && response.length > 0) {
            const sortedEvents = [...response].sort((a, b) => {
                const aIsVisit = isVisitEvent(a);
                const bIsVisit = isVisitEvent(b);
                if (aIsVisit !== bIsVisit) {
                    return aIsVisit ? -1 : 1;
                }

                const aDate = parseEventDateTime(a);
                const bDate = parseEventDateTime(b);
                if (!aDate && !bDate) return 0;
                if (!aDate) return 1;
                if (!bDate) return -1;
                return aDate - bDate;
            });
            setEventList(sortedEvents);
        } else {
            setEventList(response || []);
        }
        setEventsLoaded(true);
    }

    const apiEventAddedInfos = async () => {
        const response = await getEventAddedInfos(token, id)
        setAddedInfos(response?.addedInfos)
    }

    const handleThoughtsClick = async () => {
        await apiEventAddedInfos();
        setShowThoughtsModal(true);
    }

    const handleCreateEFModal = () => {
        if (isGestionnaireComplete) {
            setShowModalEF(true);
        }
    }

    const handleDeceasedForm = (tab) => {
        switch(tab) {
            case 'defunt':
                setShowEditDeceasedModal(true);
                break;
            case 'complementaires':
                setShowEditComplementModal(true);
                break;
            case 'obseques':
                setShowAddEventModal(true);
                break;
            default:
                console.log("Onglet inconnu");
        }
    }

    return (
        <>
            { showAddEventModal &&
                <div className="modal add-event">
                    <FormAddEvent
                        deceasedInfos={deceasedInfos}
                        setShowModal={setShowAddEventModal}
                        apiEventList={apiEventList}
                        apiDeceasedInfos={apiDeceasedInfos}
                        eventId={eventId}
                        eventKey={eventKey}
                    />
                </div>
            }
            { showEditDeceasedModal &&
                <div className=" modal">
                    <FormDeceasedInfos deceasedInfos={deceasedInfos} setDeceasedInfos={apiDeceasedInfos} setShowModal={setShowEditDeceasedModal} />
                </div>
            }
            { showEditComplementModal &&
                <div className="modal complement-modal">
                    <FormDeceasedComplement setShowModal={setShowEditComplementModal} apiDeceasedInfos={apiDeceasedInfos} />
                </div>
            }
            { showThoughtsModal &&
                <div className="modal added-infos">
                    <i onClick={() => setShowThoughtsModal(false)} className="fa fa-times close-button"/>
                    <FormAddedInfos
                        apiEventAddedInfos={apiEventAddedInfos}
                        setShowModal={setShowThoughtsModal}
                        infos={addedInfos}
                    />
                </div>
            }
            { showModalEF &&
                <div className="modal ef-infos">
                    <FormEFCreate setShowModalEF={setShowModalEF} apiDeceasedInfos={apiDeceasedInfos} deceasedInfos={deceasedInfos} correspondentInfos={correspondentInfos} adminInfos={adminInfos}/>
                </div>
            }
            <div className="deceased-main-infos column">
                <span>{!deceasedInfos?.hiddenCivility && (deceasedInfos?.civility == "MME" ? "Madame " : "Monsieur ")}{capitalize(deceasedInfos?.firstName)} {upperCaseName(deceasedInfos?.lastName)} {age !== null && `(${age} ans)`}</span>
                <h2>Informations générales</h2>
                <div className="deceased-header">
                    <h2
                        className={selectedTab === 'defunt' ? 'active' : ''}
                        onClick={() => handleTabChange('defunt')}
                    >
                        <i className="fa fa-user-circle"/>Informations du défunt
                    </h2>
                    <h2
                        className={selectedTab === 'complementaires' ? 'active' : ''}
                        onClick={() => handleTabChange('complementaires')}
                    >
                        <i className="fa fa-info-circle"/>Informations complémentaires
                    </h2>
                    <h2
                        className={selectedTab === 'obseques' ? 'active' : ''}
                        onClick={() => handleTabChange('obseques')}
                    >
                        <i className="fa fa-clock"/>Obsèques
                    </h2>
                </div>

                { selectedTab == "defunt" &&
                    <DeceasedInfos deceasedInfos={deceasedInfos} />
                }
                { selectedTab == "complementaires" &&
                    <AdminInfos
                        deceasedInfos={deceasedInfos}
                        partnerInfos={partnerInfos}
                        adminInfos={adminInfos}
                        correspondentInfos={correspondentInfos}
                        setShowEditComplementModal={setShowEditComplementModal}
                    />
                }
                { selectedTab == "obseques" &&
                    <ObsequesInfos
                        deceasedInfos={deceasedInfos}
                        eventId={eventId}
                        setEventId={setEventId}
                        eventKey={eventKey}
                        setEventKey={setEventKey}
                        eventList={eventList}
                        apiEventList={apiEventList}
                        apiDeceasedInfos={apiDeceasedInfos}
                        setShowAddEventModal={setShowAddEventModal}
                    />
                }
            </div>
            <div className="buttons-container ef-create-container">
                <button
                    type="button"
                    className="green-button ef-create-button"
                    disabled={!isGestionnaireComplete}
                    title={!isGestionnaireComplete ? "Complétez les informations du gestionnaire (Informations complémentaires) pour créer l'espace famille" : ""}
                    onClick={handleCreateEFModal}
                >
                    <i className="fa fa-plus"/><span>Créer l'espace famille</span>
                </button>
            </div>
            <div className="buttons-container">
                { selectedTab === "obseques" && eventList?.length > 0 &&
                    <button onClick={addEvent} className="green-button"><i className="fa fa-pen-to-square"/><span>Ajouter un événement</span></button>
                }
                {( selectedTab !== "obseques" || eventId !== 0 ) && !(selectedTab === "complementaires" && adminInfos?.error) &&
                    <button onClick={() => handleDeceasedForm(selectedTab)} className="red-button"><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                }
                <button onClick={handleThoughtsClick}><i className="fa fa-comment-dots"/><span>Précisions complémentaires</span></button>
            </div>
        </>
    )
}